const regions = [
  {
    'regionId': 'EAUSSIE',
    'regionName': 'Eastern Australia',
  },
  {
    'regionId': 'SOUTHERNAFRICA',
    'regionName': 'Southern Africa',
  },
  {
    'regionId': 'ECSA',
    'regionName': 'East Coast South America',
  },
  {
    'regionId': 'NCSA',
    'regionName': 'North Coast South America',
  },
  {
    'regionId': 'BALTIC',
    'regionName': 'Baltic',
  },
  {
    'regionId': 'WCSA',
    'regionName': 'West Coast South America',
  },
  {
    'regionId': 'ECCA',
    'regionName': 'East Coast Central America',
  },
  {
    'regionId': 'EASTAFRICA',
    'regionName': 'East Africa',
  },
  {
    'regionId': 'WESTMED',
    'regionName': 'Western Mediterranean',
  },
  {
    'regionId': 'NWAFRICA',
    'regionName': 'North Western Africa',
  },
  {
    'regionId': 'WCINDIA',
    'regionName': 'West Coast India',
  },
  {
    'regionId': 'ECINDIA',
    'regionName': 'East Coast India',
  },
  {
    'regionId': 'WAUSSIE',
    'regionName': 'Western Australia',
  },
  {
    'regionId': 'SEA',
    'regionName': 'South East Asia',
  },
  {
    'regionId': 'REDSEA',
    'regionName': 'Red Sea',
  },
  {
    'regionId': 'AG',
    'regionName': 'Arabian Gulf',
  },
  {
    'regionId': 'BLACKSEA',
    'regionName': 'Black Sea',
  },
  {
    'regionId': 'CARRIBEAN',
    'regionName': 'Carribean',
  },
  {
    'regionId': 'USEC',
    'regionName': 'US East Coast',
  },
  {
    'regionId': 'EASTMED',
    'regionName': 'Eastern Mediterranean',
  },
  {
    'regionId': 'FAREAST',
    'regionName': 'Far East',
  },
  {
    'regionId': 'USG',
    'regionName': 'US Gulf',
  },
  {
    'regionId': 'WCCA',
    'regionName': 'West Coast Central America',
  },
  {
    'regionId': 'USWC',
    'regionName': 'US West Coast',
  },
  {
    'regionId': 'CONT',
    'regionName': 'Continent',
  }
];

export {
  regions
}